import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import hero from '../Assets/content.svg';

import logo from '../Assets/LOGO_CFCAE.png';

const Content = () => {
	const location = useLocation();
	const { hash } = useLocation();
	useEffect(() => {
		if (hash) {
			const target = document.querySelector(hash);
			if (target) {
				window.scrollTo({ top: 0, behavior: 'smooth' });
			}
		}
	}, [hash]);

	// Determine the height based on the current route
	const isHome = location.pathname === '/';
	const heightClass = isHome ? 'h-[100vh]' : 'h-[30vh]';
	const logoDim = isHome ? 'w-56 h-auto' : 'hidden';
	const FontClass = isHome
		? 'md:text-5xl lg:text-6xl sm:text-3xl text-xl sm:border-l-4 sm:border-l-[#87152B]'
		: 'md:text-3xl lg:text-2xl sm:text-2xl text-xl mt-16';

	return (
		<div
			id='#top'
			className={`text-white bg-white bg-no-repeat mt-20 bg-right transition-all ease-in-out duration-500 ${heightClass}`}
			style={{
				backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 0.8) 30%, rgba(255, 255, 255, 0.4) 60%, rgba(255, 255, 255, 0) 80%), url(${hero})`
			}}
		>
			<div className='flex flex-col sm:flex-row items-center justify-center w-full h-full '>
				<img
					src={logo}
					alt='Logo CFCAE - Cabinet de Formation et Habilitation Électrique Casablanca'
					className={` animate-slide-in transition-all ease-in-out duration-500 sm:ml-20 ${logoDim}`}
				/>
				<div className='w-[80%] h-[10%] sm:h-[80%] flex items-center justify-center sm:justify-start '>
					{/* Modification SEO : Passage en <h1> avec mots-clés stratégiques */}
					<h1
						className={`animate-slide-in text-black font-bold p-2 transition-all ease-in-out duration-1000 ${FontClass}`}
					>
						{isHome && (
							<span className='sr-only'>
								Centre de Formation Professionnelle & Habilitation Électrique à Casablanca - CFCAE
							</span>
						)}
						<span className='block'>
							SE<span className='text-[#87152B]'> FORMER</span>,
							<br />
							C’EST <span className='text-[#AC9961]'>AVANCER</span> !
						</span>
					</h1>
				</div>
			</div>
		</div>
	);
};

export default Content;